import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import * as fromFeatureReducers from './features.state'
import * as fromPlanningReducers from './program-increment-store/store/reducers/'

/**
 * This module ONLY registers the store state (reducers).
 * It does NOT include effects (no HTTP calls).
 * Import this in CoreModule or AppModule to ensure the store is initialized early.
 */
@NgModule({
  imports: [
    StoreModule.forFeature(
      fromFeatureReducers.FEATURE_NAME,
      fromFeatureReducers.reducers
    )
  ]
})
export class FeaturesStateModule {}
